import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "register-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "page-content" }
const _hoisted_4 = { class: "tab-header" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "actions" }
const _hoisted_7 = { class: "tab-content" }

import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter, useRoute } from "vue-router";

import { toast } from "@/common/utils/toast";

import { platformGet } from "@/common/api/rest/platform";
import { groupGet, groupPatch } from "@/common/api/rest/group";

import type { TranslationFieldsType } from "@/common/types/translation";
import type { PlatformType } from "@/common/types/platform";
import type { GroupType } from "@/common/types/group";

import { FormGroup, ListTranslate } from "@/components";
import { breadcrumbSimple, svgIcon } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'edit',
  setup(__props) {

const { t, locale } = useI18n();
const router = useRouter();
const route = useRoute();

const translationFields = ref<TranslationFieldsType[]>([
  {
    type: "input",
    field: "name",
    label: "common.labels.name",
    value: "",
  },
  {
    type: "textarea",
    field: "description",
    label: "common.labels.description",
    value: "",
  },
]);

const platformData = ref<PlatformType | null>(null);
const groupData = ref<GroupType | null>(null);

const loading = ref(true);

const platformId = computed(() => route.params.platform as string);
const groupId = computed(() => route.params.group as string);

const breadcrumbList = computed(() => [
  {
    key: "register",
    label: t("common.labels.registrations"),
    url: "/register",
  },
  {
    key: "platforms",
    label: t("common.labels.platforms"),
    url: `/register/platform`,
  },
  {
    key: "platform",
    label: platformData.value?.name ?? "...",
    url: `/register/platform/${platformId.value}/edit`,
  },
  {
    key: "groups",
    label: t("group.labels.groups"),
    url: `/register/platform/${platformId.value}/group`,
  },
  {
    key: "edit",
    label: groupData.value?.name ?? "...",
  },
]);

function back() {
  router.push(`/register/platform/${platformId.value}/group`);
}

// PLATFORM
async function fetchPlatform() {
  await platformGet(platformId.value)
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        platformData.value = data;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

// GROUP
async function fetchGroup() {
  await groupGet(groupId.value)
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        groupData.value = data;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      loading.value = false;
    });
}

async function patchData(payload: Partial<GroupType>) {
  await groupPatch(groupId.value, payload)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchGroup();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

onMounted(async () => {
  await fetchPlatform();
  await fetchGroup();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_unref(breadcrumbSimple), {
        items: breadcrumbList.value,
        "show-home": true,
        "url-home": "/home",
        active: "edit"
      }, null, 8, ["items"])
    ]),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(svgIcon), {
            icon: "platform",
            size: "2rem"
          }),
          _createTextVNode(" " + _toDisplayString(_unref(t)("platform.labels.edit_platform")) + " | " + _toDisplayString(_unref(t)("group.labels.edit_group")), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "btn btn-default",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (back()))
          }, [
            _createVNode(_unref(svgIcon), {
              icon: "close",
              size: "1rem"
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(), _createBlock(_unref(FormGroup), {
          key: loading.value ? 0 : 1,
          "is-patch": true,
          data: groupData.value,
          "onUpdate:data": _cache[1] || (_cache[1] = ($event: any) => (patchData($event)))
        }, null, 8, ["data"])),
        _createVNode(_unref(ListTranslate), {
          "owner-id": groupId.value,
          language: _unref(locale).toLowerCase(),
          fields: translationFields.value
        }, null, 8, ["owner-id", "language", "fields"])
      ])
    ])
  ]))
}
}

})